export default __webpack_public_path__ + "static/media/victoria-ricca-2.18ad9b97.webp";